'use strict';

/**
 * Init globally reusable video players
 */

module.exports = {
    videoPlayerEvents: function () {
        $('.youtube-picture').on('click', function () {
            const $youtubeVideo = $(this).next('.youtube-video');
            const $youtubeIframe = $('<iframe></iframe>');
            var finalURL = $youtubeVideo.attr('data-src');

            if (!finalURL.includes('&rel=0')) {
                finalURL += '&rel=0';
            }

            $youtubeIframe.attr({
                src: finalURL,
                frameborder: 0,
                allow: $youtubeVideo.attr('data-allow'),
                allowfullscreen: true
            });

            $(this).hide();
            $youtubeVideo.append($youtubeIframe).show();
        });
    }
};
